import { useEffect } from "react";
import "./LegalPages.css";

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Use</h1>
        <p className="last-updated">Last Updated: January 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using the Speak With Simon website ("Website"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily download one copy of the materials on Speak With Simon's Website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>modify or copy the materials;</li>
            <li>use the materials for any commercial purpose or for any public display (commercial or non-commercial);</li>
            <li>attempt to reverse engineer any software contained on Speak With Simon's Website;</li>
            <li>remove any copyright or other proprietary notations from the materials; or</li>
            <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
          </ul>
          <p>
            This license shall automatically terminate if you violate any of these restrictions and may be terminated by Speak With Simon at any time.
          </p>
        </section>

        <section>
          <h2>3. Services</h2>
          <p>
            Speak With Simon provides public speaking coaching, speech writing services, and related communication training services. All services are provided subject to these Terms of Use and any additional terms and conditions that may apply to specific services.
          </p>
          <p>
            We reserve the right to modify, suspend, or discontinue any service at any time without notice. We do not guarantee that any service will be available at all times or that it will be error-free.
          </p>
        </section>

        <section>
          <h2>4. Payment Terms</h2>
          <p>
            Payment for services must be made in accordance with the terms specified at the time of purchase. All fees are non-refundable unless otherwise stated in writing. We reserve the right to change our pricing at any time, but such changes will not affect services already purchased.
          </p>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>
          <p>
            The Website and its original content, features, and functionality are owned by Speak With Simon and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
          </p>
          <p>
            The "TED" and "TEDx" trademarks are owned by TED Conferences LLC. Speak With Simon is independent and not affiliated with, sponsored by, or endorsed by TED Conferences LLC or its affiliates.
          </p>
        </section>

        <section>
          <h2>6. User Content</h2>
          <p>
            If you submit any content to us, including but not limited to feedback, testimonials, or materials for coaching services, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and distribute such content for the purpose of providing our services and marketing our business.
          </p>
        </section>

        <section>
          <h2>7. Disclaimer</h2>
          <p>
            The materials on Speak With Simon's Website are provided on an 'as is' basis. Speak With Simon makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>
        </section>

        <section>
          <h2>8. Limitations</h2>
          <p>
            In no event shall Speak With Simon or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Speak With Simon's Website, even if Speak With Simon or a Speak With Simon authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>
        </section>

        <section>
          <h2>9. Accuracy of Materials</h2>
          <p>
            The materials appearing on Speak With Simon's Website could include technical, typographical, or photographic errors. Speak With Simon does not warrant that any of the materials on its Website are accurate, complete, or current. Speak With Simon may make changes to the materials contained on its Website at any time without notice.
          </p>
        </section>

        <section>
          <h2>10. Links</h2>
          <p>
            Speak With Simon has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Speak With Simon of the site. Use of any such linked website is at the user's own risk.
          </p>
        </section>

        <section>
          <h2>11. Modifications</h2>
          <p>
            Speak With Simon may revise these terms of service for its Website at any time without notice. By using this Website you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section>
          <h2>12. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which Speak With Simon operates, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>
        </section>

        <section>
          <h2>13. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Use, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> a.simon@speakwithsimon.com
          </p>
        </section>

        <div className="legal-back-link">
          <a href="#" onClick={(e) => { e.preventDefault(); window.location.hash = ""; window.location.reload(); }}>← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

